// // import React, { useEffect, useState } from "react";
// // import "./EmployeeList.css";

// // export default function EmployeeList() {
// //   const [employees, setEmployees] = useState([]);

// //   useEffect(() => {
// //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/get_employees.php") // 🔹 Replace with your actual Hostinger PHP URL
// //       .then((res) => res.json())
// //       .then((data) => setEmployees(data))
// //       .catch((err) => console.error("Error fetching data:", err));
// //   }, []);

// //   return (
// //     <div className="container">
// //       <h1>Employee List</h1>
// //       <table>
// //         <thead>
// //           <tr>
// //             <th>ID</th>
// //             <th>Full Name</th>
// //             <th>Phone</th>
// //             <th>Email</th>
// //             <th>Department</th>
// //             <th>Designation</th>
// //             <th>Status</th>
// //             <th>Date Joined</th>
// //           </tr>
// //         </thead>
// //         <tbody>
// //           {employees.length > 0 ? (
// //             employees.map((emp) => (
// //               <tr key={emp.employee_id}>
// //                 <td>{emp.employee_id}</td>
// //                 <td>{emp.full_name}</td>
// //                 <td>{emp.phone_number}</td>
// //                 <td>{emp.email}</td>
// //                 <td>{emp.department}</td>
// //                 <td>{emp.designation}</td>
// //                 <td>{emp.status}</td>
// //                 <td>{emp.date_joined}</td>
// //               </tr>
// //             ))
// //           ) : (
// //             <tr>
// //               <td colSpan="8">No employees found.</td>
// //             </tr>
// //           )}
// //         </tbody>
// //       </table>
// //     </div>
// //   );
// // }



// // import React, { useEffect, useState } from "react";
// // import "./EmployeeList.css";

// // export default function EmployeeList() {
// //   const [employees, setEmployees] = useState([]);
// //   const [editingEmployee, setEditingEmployee] = useState(null);
// //   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
// //   const [employeeToDelete, setEmployeeToDelete] = useState(null);

// //   useEffect(() => {
// //     fetchEmployees();
// //   }, []);

// //   const fetchEmployees = () => {
// //     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/get_employees.php")
// //       .then((res) => res.json())
// //       .then((data) => setEmployees(data))
// //       .catch((err) => console.error("Error fetching data:", err));
// //   };

// //   const handleEditClick = (emp) => {
// //     setEditingEmployee(emp);
// //   };

// //   const handleDeleteClick = (emp) => {
// //     setEmployeeToDelete(emp);
// //     setShowDeleteConfirm(true);
// //   };

// //   const handleDeleteConfirm = () => {
// //     fetch(`https://www.actrofiteinfotech.com/rootservices/dashboard/delete_employee.php`, {
// //       method: "POST",
// //       headers: { "Content-Type": "application/json" },
// //       body: JSON.stringify({ employee_id: employeeToDelete.employee_id }),
// //     })
// //       .then((res) => res.json())
// //       .then((data) => {
// //         if (data.success) {
// //           fetchEmployees();
// //           setShowDeleteConfirm(false);
// //           setEmployeeToDelete(null);
// //         } else {
// //           alert("Failed to delete employee");
// //         }
// //       });
// //   };

// //   const handleEditSave = () => {
// //     fetch(`https://www.actrofiteinfotech.com/rootservices/dashboard/edit_employee.php`, {
// //       method: "POST",
// //       headers: { "Content-Type": "application/json" },
// //       body: JSON.stringify(editingEmployee),
// //     })
// //       .then((res) => res.json())
// //       .then((data) => {
// //         if (data.success) {
// //           fetchEmployees();
// //           setEditingEmployee(null);
// //         } else {
// //           alert("Failed to update employee");
// //         }
// //       });
// //   };

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setEditingEmployee({ ...editingEmployee, [name]: value });
// //   };

// //   return (
// //     <div className="container">
// //       <h1>Employee List</h1>
// //       <table>
// //         <thead>
// //           <tr>
// //             <th>ID</th>
// //             <th>Full Name</th>
// //             <th>username</th>
// //             <th>Phone</th>
// //             <th>Email</th>
// //             <th>Department</th>
// //             <th>Designation</th>
// //             <th>Status</th>
// //             {/* <th>Date Joined</th> */}
// //             <th>Edit</th>
// //             <th>Delete</th>
// //           </tr>
// //         </thead>
// //         <tbody>
// //           {employees.length > 0 ? (
// //             employees.map((emp) => (
// //               <tr key={emp.employee_id}>
// //                 <td>{emp.employee_id}</td>
// //                 <td>{emp.full_name}</td>
// //                 <td>{emp.username}</td>
// //                 <td>{emp.phone_number}</td>
// //                 <td>{emp.email}</td>
// //                 <td>{emp.department}</td>
// //                 <td>{emp.designation}</td>
// //                 <td>{emp.status}</td>
// //                 {/* <td>{emp.date_joined}</td> */}
// //                 <td>
// //                   <button onClick={() => handleEditClick(emp)}>Edit</button>
// //                 </td>
// //                 <td>
// //                   <button onClick={() => handleDeleteClick(emp)}>Delete</button>
// //                 </td>
// //               </tr>
// //             ))
// //           ) : (
// //             <tr>
// //               <td colSpan="9">No employees found.</td>
// //             </tr>
// //           )}
// //         </tbody>
// //       </table>

// //       {/* Edit Modal */}
// //       {/* Edit Modal */}
// // {editingEmployee && (
// //   <div className="modal">
// //     <div className="modal-content">
// //       <h3>Edit Employee</h3>
// //       <input
// //         type="text"
// //         name="full_name"
// //         placeholder="Full Name"
// //         value={editingEmployee.full_name}
// //         onChange={handleInputChange}
// //       />
// //       <input
// //         type="text"
// //         name="username"
// //         placeholder="Username"
// //         value={editingEmployee.username}
// //         onChange={handleInputChange}
// //       />
// //       <input
// //         type="text"
// //         name="phone_number"
// //         placeholder="Phone Number"
// //         value={editingEmployee.phone_number}
// //         onChange={handleInputChange}
// //       />
// //       <input
// //         type="email"
// //         name="email"
// //         placeholder="Email"
// //         value={editingEmployee.email}
// //         onChange={handleInputChange}
// //       />
// //       <input
// //         type="text"
// //         name="department"
// //         placeholder="Department"
// //         value={editingEmployee.department}
// //         onChange={handleInputChange}
// //       />
// //       <input
// //         type="text"
// //         name="designation"
// //         placeholder="Designation"
// //         value={editingEmployee.designation}
// //         onChange={handleInputChange}
// //       />
// //       <select
// //   name="status"
// //   value={editingEmployee.status}
// //   onChange={handleInputChange}
// // >
// //   <option value="Active">Active</option>
// //   <option value="Inactive">Inactive</option>
// // </select>

// //       <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
// //         <button onClick={handleEditSave}>Save</button>
// //         <button onClick={() => setEditingEmployee(null)}>Cancel</button>
// //       </div>
// //     </div>
// //   </div>
// // )}


// //       {/* Delete Confirmation Modal */}
// //       {showDeleteConfirm && (
// //         <div className="modal">
// //           <div className="modal-content">
// //             <h3>Confirm Delete</h3>
// //             <p>Are you sure you want to delete this employee?</p>
// //             <p>
// //               <strong>{employeeToDelete.full_name}</strong> ({employeeToDelete.email})
// //             </p>
// //             <button onClick={handleDeleteConfirm}>Yes, Delete</button>
// //             <button
// //               onClick={() => {
// //                 setShowDeleteConfirm(false);
// //                 setEmployeeToDelete(null);
// //               }}
// //             >
// //               Cancel
// //             </button>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }


// import React, { useEffect, useState } from "react";
// import "./EmployeeList.css";

// export default function EmployeeList() {
//   const [employees, setEmployees] = useState([]);
//   const [editingEmployee, setEditingEmployee] = useState(null);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [employeeToDelete, setEmployeeToDelete] = useState(null);

//   useEffect(() => {
//     fetchEmployees();
//   }, []);

//   const fetchEmployees = () => {
//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/get_employees.php")
//       .then((res) => res.json())
//       .then((data) => setEmployees(data))
//       .catch((err) => console.error("Error fetching data:", err));
//   };

//   const handleEditClick = (emp) => {
//     setEditingEmployee(emp);
//   };

//   const handleDeleteClick = (emp) => {
//     setEmployeeToDelete(emp);
//     setShowDeleteConfirm(true);
//   };

//   const handleDeleteConfirm = () => {
//     fetch(`https://www.actrofiteinfotech.com/rootservices/dashboard/delete_employee.php`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ employee_id: employeeToDelete.employee_id }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.success) {
//           fetchEmployees();
//           setShowDeleteConfirm(false);
//           setEmployeeToDelete(null);
//         } else {
//           alert("Failed to delete employee");
//         }
//       });
//   };

//   const handleEditSave = () => {
//     fetch(`https://www.actrofiteinfotech.com/rootservices/dashboard/edit_employee.php`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(editingEmployee),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.success) {
//           fetchEmployees();
//           setEditingEmployee(null);
//         } else {
//           alert("Failed to update employee");
//         }
//       });
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditingEmployee({ ...editingEmployee, [name]: value });
//   };

//   // ✅ Inactive All handler
//   const handleInactiveAll = () => {
//     const password = prompt("Enter admin password to inactivate all employees:");
//     if (password !== "adminatp123") {
//       alert("Incorrect password!");
//       return;
//     }

//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/inactive_all_employees.php", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ password }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.success) {
//           fetchEmployees();
//           alert("All employees set to Inactive!");
//         } else {
//           alert(data.message || "Failed to update employees");
//         }
//       })
//       .catch((err) => console.error(err));
//   };

//   return (
//     <div className="container">
//       <h1>Employee List</h1>
//       <table>
//         <thead>
//           <tr>
//             <th>ID</th>
//             <th>Full Name</th>
//             <th>Username</th>
//             <th>Phone</th>
//             <th>Email</th>
//             <th>Department</th>
//             <th>Designation</th>
//             <th>Status</th>
//             <th>Edit</th>
//             <th>Delete</th>
//           </tr>
//         </thead>
//         <tbody>
//           {employees.length > 0 ? (
//             employees.map((emp) => (
//               <tr key={emp.employee_id}>
//                 <td>{emp.employee_id}</td>
//                 <td>{emp.full_name}</td>
//                 <td>{emp.username}</td>
//                 <td>{emp.phone_number}</td>
//                 <td>{emp.email}</td>
//                 <td>{emp.department}</td>
//                 <td>{emp.designation}</td>
//                 <td>{emp.status}</td>
//                 <td>
//                   <button onClick={() => handleEditClick(emp)}>Edit</button>
//                 </td>
//                 <td>
//                   <button onClick={() => handleDeleteClick(emp)}>Delete</button>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="10">No employees found.</td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       {/* Edit Modal */}
//       {editingEmployee && (
//         <div className="modal">
//           <div className="modal-content">
//             <h3>Edit Employee</h3>
//             <input
//               type="text"
//               name="full_name"
//               placeholder="Full Name"
//               value={editingEmployee.full_name}
//               onChange={handleInputChange}
//             />
//             <input
//               type="text"
//               name="username"
//               placeholder="Username"
//               value={editingEmployee.username}
//               onChange={handleInputChange}
//             />
//             <input
//               type="text"
//               name="phone_number"
//               placeholder="Phone Number"
//               value={editingEmployee.phone_number}
//               onChange={handleInputChange}
//             />
//             <input
//               type="email"
//               name="email"
//               placeholder="Email"
//               value={editingEmployee.email}
//               onChange={handleInputChange}
//             />
//             <input
//               type="text"
//               name="department"
//               placeholder="Department"
//               value={editingEmployee.department}
//               onChange={handleInputChange}
//             />
//             <input
//               type="text"
//               name="designation"
//               placeholder="Designation"
//               value={editingEmployee.designation}
//               onChange={handleInputChange}
//             />
//             <select name="status" value={editingEmployee.status} onChange={handleInputChange}>
//               <option value="Active">Active</option>
//               <option value="Inactive">Inactive</option>
//             </select>

//             <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
//               <button onClick={handleEditSave}>Save</button>
//               <button onClick={() => setEditingEmployee(null)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       {showDeleteConfirm && (
//         <div className="modal">
//           <div className="modal-content">
//             <h3>Confirm Delete</h3>
//             <p>Are you sure you want to delete this employee?</p>
//             <p>
//               <strong>{employeeToDelete.full_name}</strong> ({employeeToDelete.email})
//             </p>
//             <button onClick={handleDeleteConfirm}>Yes, Delete</button>
//             <button
//               onClick={() => {
//                 setShowDeleteConfirm(false);
//                 setEmployeeToDelete(null);
//               }}
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ✅ Inactive All Button */}
//       <div style={{ marginTop: "20px", textAlign: "center" }}>
//         <button onClick={handleInactiveAll} style={{ padding: "10px 20px", backgroundColor: "#f44336", color: "#fff", border: "none", borderRadius: "5px" }}>
//           Inactive All
//         </button>
//       </div>
//     </div>
//   );
// }













// import React, { useEffect, useState } from 'react';

// export default function EmployeeListInline() {
//   const [employees, setEmployees] = useState([]);
//   const [editingEmployee, setEditingEmployee] = useState(null);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [employeeToDelete, setEmployeeToDelete] = useState(null);

//   useEffect(() => {
//     fetchEmployees();
//   }, []);

//   const fetchEmployees = () => {
//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/get_employees.php")
//       .then(res => res.json())
//       .then(data => setEmployees(data))
//       .catch(err => console.error("Error fetching data:", err));
//   };

//   const handleEditClick = (emp) => setEditingEmployee(emp);
//   const handleDeleteClick = (emp) => {
//     setEmployeeToDelete(emp);
//     setShowDeleteConfirm(true);
//   };

//   const handleDeleteConfirm = () => {
//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/delete_employee.php", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ employee_id: employeeToDelete.employee_id })
//     })
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           fetchEmployees();
//           setShowDeleteConfirm(false);
//           setEmployeeToDelete(null);
//         } else {
//           alert("Failed to delete employee");
//         }
//       });
//   };

//   const handleEditSave = () => {
//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/edit_employee.php", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(editingEmployee)
//     })
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           fetchEmployees();
//           setEditingEmployee(null);
//         } else alert("Failed to update employee");
//       });
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditingEmployee({ ...editingEmployee, [name]: value });
//   };

//   const handleInactiveAll = () => {
//     const password = prompt("Enter admin password to inactivate all employees:");
//     if (password !== "adminatp123") {
//       alert("Incorrect password!");
//       return;
//     }

//     fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/inactive_all_employees.php", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ password })
//     })
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           fetchEmployees();
//           alert("All employees set to Inactive!");
//         } else alert(data.message || "Failed to update employees");
//       })
//       .catch(console.error);
//   };

//   // Inline styles
//   const containerStyle = {
//     width: "95%",
//     margin: "30px auto",
//     backgroundColor: "#fff",
//     borderRadius: "12px",
//     padding: "20px",
//     boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//     overflowX: "auto"
//   };

//   const titleStyle = { textAlign: "center", fontSize: "24px", marginBottom: "20px", color: "#1c1c1c", fontWeight: 600 };

//   const tableStyle = { width: "100%", borderCollapse: "collapse", minWidth: "900px" };

//   const thStyle = { padding: "12px", backgroundColor: "#2e86de", color: "#fff", border: "1px solid #fff", fontSize: "14px" };
//   const tdStyle = { padding: "12px", textAlign: "center", fontSize: "14px", border: "1px solid #ddd" };

//   const rowStyle = (index) => ({ backgroundColor: index % 2 === 0 ? "#f1f5f8" : "#fff", transition: "background 0.3s" });
//   const rowHoverStyle = { backgroundColor: "#d6e6ff" };

//   const buttonStyle = { padding: "6px 12px", margin: "0 4px", border: "none", borderRadius: "5px", cursor: "pointer" };
//   const editButtonStyle = { ...buttonStyle, backgroundColor: "#27ae60", color: "#fff" };
//   const deleteButtonStyle = { ...buttonStyle, backgroundColor: "#f44336", color: "#fff" };
//   const inactiveAllStyle = { padding: "10px 20px", backgroundColor: "#f44336", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" };

//   const modalOverlayStyle = {
//     position: "fixed",
//     top: 0, left: 0, width: "100%", height: "100%",
//     backgroundColor: "rgba(0,0,0,0.5)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     zIndex: 1000
//   };
//   const modalContentStyle = {
//     backgroundColor: "#fff",
//     padding: "20px",
//     borderRadius: "10px",
//     width: "400px",
//     maxWidth: "90%",
//     display: "flex",
//     flexDirection: "column",
//     gap: "10px"
//   };
//   const inputStyle = { padding: "8px", fontSize: "14px", borderRadius: "5px", border: "1px solid #ccc", width: "100%" };
//   const selectStyle = { ...inputStyle };

//   return (
//     <div style={containerStyle}>
//       <h1 style={titleStyle}>Employee List</h1>
//       <table style={tableStyle}>
//         <thead>
//           <tr>
//             {["ID","Full Name","Username","Phone","Email","Department","Designation","Status","Edit","Delete"].map((head) => (
//               <th key={head} style={thStyle}>{head}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {employees.length > 0 ? employees.map((emp, index) => (
//             <tr key={emp.employee_id} style={rowStyle(index)}
//                 onMouseEnter={e => e.currentTarget.style.backgroundColor = "#d6e6ff"}
//                 onMouseLeave={e => e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f1f5f8" : "#fff"}>
//               <td style={tdStyle}>{emp.employee_id}</td>
//               <td style={tdStyle}>{emp.full_name}</td>
//               <td style={tdStyle}>{emp.username}</td>
//               <td style={tdStyle}>{emp.phone_number}</td>
//               <td style={tdStyle}>{emp.email}</td>
//               <td style={tdStyle}>{emp.department}</td>
//               <td style={tdStyle}>{emp.designation}</td>
//               <td style={tdStyle}>{emp.status}</td>
//               <td style={tdStyle}><button style={editButtonStyle} onClick={() => handleEditClick(emp)}>Edit</button></td>
//               <td style={tdStyle}><button style={deleteButtonStyle} onClick={() => handleDeleteClick(emp)}>Delete</button></td>
//             </tr>
//           )) : (
//             <tr>
//               <td style={tdStyle} colSpan="10">No employees found.</td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//       {/* Edit Modal */}
//       {editingEmployee && (
//         <div style={modalOverlayStyle}>
//           <div style={modalContentStyle}>
//             <h3>Edit Employee</h3>
//             <input style={inputStyle} type="text" name="full_name" placeholder="Full Name" value={editingEmployee.full_name} onChange={handleInputChange} />
//             <input style={inputStyle} type="text" name="username" placeholder="Username" value={editingEmployee.username} onChange={handleInputChange} />
//             <input style={inputStyle} type="text" name="phone_number" placeholder="Phone Number" value={editingEmployee.phone_number} onChange={handleInputChange} />
//             <input style={inputStyle} type="email" name="email" placeholder="Email" value={editingEmployee.email} onChange={handleInputChange} />
//             <input style={inputStyle} type="text" name="department" placeholder="Department" value={editingEmployee.department} onChange={handleInputChange} />
//             <input style={inputStyle} type="text" name="designation" placeholder="Designation" value={editingEmployee.designation} onChange={handleInputChange} />
//             <select style={selectStyle} name="status" value={editingEmployee.status} onChange={handleInputChange}>
//               <option value="Active">Active</option>
//               <option value="Inactive">Inactive</option>
//             </select>
//             <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
//               <button style={editButtonStyle} onClick={handleEditSave}>Save</button>
//               <button style={deleteButtonStyle} onClick={() => setEditingEmployee(null)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       {showDeleteConfirm && (
//         <div style={modalOverlayStyle}>
//           <div style={modalContentStyle}>
//             <h3>Confirm Delete</h3>
//             <p>Are you sure you want to delete this employee?</p>
//             <p><strong>{employeeToDelete.full_name}</strong> ({employeeToDelete.email})</p>
//             <div style={{ display: "flex", justifyContent: "space-between" }}>
//               <button style={deleteButtonStyle} onClick={handleDeleteConfirm}>Yes, Delete</button>
//               <button style={editButtonStyle} onClick={() => { setShowDeleteConfirm(false); setEmployeeToDelete(null); }}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Inactive All Button */}
//       <div style={{ marginTop: "20px", textAlign: "center" }}>
//         <button style={inactiveAllStyle} onClick={handleInactiveAll}>Inactive All</button>
//       </div>
//     </div>
//   );
// }










// shaiksha added






import React, { useEffect, useState } from 'react';

export default function EmployeeListInline() {
  const [employees, setEmployees] = useState([]);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Track window width
  const [selectedEmployee, setSelectedEmployee] = useState(null); // Track selected employee for modal

  useEffect(() => {
    fetchEmployees();
    window.addEventListener('resize', handleResize); // Add event listener for window resize
    return () => window.removeEventListener('resize', handleResize); // Clean up listener
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth); // Update window width on resize
  };

  const fetchEmployees = () => {
    fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/get_employees.php")
      .then(res => res.json())
      .then(data => setEmployees(data))
      .catch(err => console.error("Error fetching data:", err));
  };

  const handleEmployeeSelect = (emp) => {
    setSelectedEmployee(emp); // Set selected employee data to show in modal
  };

  const handleEditClick = (emp) => setEditingEmployee(emp);
  const handleDeleteClick = (emp) => {
    setEmployeeToDelete(emp);
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = () => {
    fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/delete_employee.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ employee_id: employeeToDelete.employee_id })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          fetchEmployees();
          setShowDeleteConfirm(false);
          setEmployeeToDelete(null);
        } else {
          alert("Failed to delete employee");
        }
      });
  };

  const handleEditSave = () => {
    fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/edit_employee.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editingEmployee)
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          fetchEmployees();
          setEditingEmployee(null);
        } else alert("Failed to update employee");
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditingEmployee({ ...editingEmployee, [name]: value });
  };

  const handleInactiveAll = () => {
    const password = prompt("Enter admin password to inactivate all employees:");
    if (password !== "adminatp123") {
      alert("Incorrect password!");
      return;
    }

    fetch("https://www.actrofiteinfotech.com/rootservices/dashboard/inactive_all_employees.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          fetchEmployees();
          alert("All employees set to Inactive!");
        } else alert(data.message || "Failed to update employees");
      })
      .catch(console.error);
  };

  // Inline styles with dynamic media query-like adjustments
  const containerStyle = {
    width: "95%",
    margin: "30px auto",
    marginLeft: "0px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: windowWidth < 768 ? "15px" : "15px",  // Adjust padding based on screen size
    boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    overflowX: "auto"
  };

  const titleStyle = { 
    textAlign: "center", 
    fontSize: windowWidth < 768 ? "20px" : "24px",  // Adjust font size for small screens
    marginBottom: "20px", 
    color: "#1c1c1c", 
    fontWeight: 600 
  };

  const selectStyle = {
    padding: "8px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    width: "100%",
    marginBottom: "20px"
  };

  const tableContainerStyle = {
    width: "100%",
    overflowX: "auto", // Enable horizontal scrolling for smaller screens
  };

  const tableStyle = { 
    width: "100%", 
    borderCollapse: "collapse", 
    minWidth: windowWidth < 768 ? "600px" : "1000px",  // Ensure table width stretches for larger screens
    tableLayout: "auto", // Allows table to expand and scroll if necessary
    whiteSpace: "nowrap" // Prevents wrapping of content and ensures horizontal scrolling
  };

  const thStyle = { padding: "10px", backgroundColor: "#2e86de", color: "#fff", border: "1px solid #fff", fontSize: "13px" };
  const tdStyle = { padding: "10px", textAlign: "center", fontSize: "13px", border: "1px solid #ddd" };

  const rowStyle = (index) => ({ backgroundColor: index % 2 === 0 ? "#f1f5f8" : "#fff", transition: "background 0.3s" });
  const rowHoverStyle = { backgroundColor: "#d6e6ff" };

  const buttonStyle = { padding: "6px 8px", margin: "0 3px", border: "none", borderRadius: "5px", cursor: "pointer" };
  const editButtonStyle = { ...buttonStyle, backgroundColor: "#27ae60", color: "#fff" };
  const deleteButtonStyle = { ...buttonStyle, backgroundColor: "#f44336", color: "#fff" };

  const modalOverlayStyle = {
    position: "fixed",
    top: 0, left: 0, width: "100%", height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
  };

  const modalContentStyle = {
    backgroundColor: "#fff",
    padding: windowWidth < 768 ? "15px" : "20px",  // Adjust modal padding for smaller screens
    borderRadius: "10px",
    width: windowWidth < 768 ? "90%" : "400px",  // Adjust modal width for small screens
    display: "flex",
    flexDirection: "column",
    gap: "10px"
  };

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>Employee List</h1>

      {/* Dropdown for small screens */}
      {windowWidth < 768 && (
        <div>
          <select style={selectStyle} onChange={(e) => handleEmployeeSelect(employees.find(emp => emp.employee_id === e.target.value))}>
            <option value="">Select Employee</option>
            {employees.map((emp) => (
              <option key={emp.employee_id} value={emp.employee_id}>
                {emp.full_name} (ID: {emp.employee_id})
              </option>
            ))}
          </select>
        </div>  
      )}

      {/* Table for larger screens */}
      {windowWidth >= 768 && (
        <div style={tableContainerStyle}>
          <table style={tableStyle}>
            <thead>
              <tr>
                {["ID", "Full Name", "Username", "Phone", "Email", "Department", "Designation", "Status", "Edit", "Delete"].map((head) => (
                  <th key={head} style={thStyle}>{head}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {employees.length > 0 ? employees.map((emp, index) => (
                <tr key={emp.employee_id} style={rowStyle(index)}>
                  <td style={tdStyle}>{emp.employee_id}</td>
                  <td style={tdStyle}>{emp.full_name}</td>
                  <td style={tdStyle}>{emp.username}</td>
                  <td style={tdStyle}>{emp.phone_number}</td>
                  <td style={tdStyle}>{emp.email}</td>
                  <td style={tdStyle}>{emp.department}</td>
                  <td style={tdStyle}>{emp.designation}</td>
                  <td style={tdStyle}>{emp.status}</td>
                  <td style={tdStyle}><button style={editButtonStyle} onClick={() => handleEditClick(emp)}>Edit</button></td>
                  <td style={tdStyle}><button style={deleteButtonStyle} onClick={() => handleDeleteClick(emp)}>Delete</button></td>
                </tr>
              )) : (
                <tr>
                  <td style={tdStyle} colSpan="10">No employees found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Employee Details Modal for small screens */}
      {selectedEmployee && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3>Employee Details</h3>
            <p><strong>ID:</strong> {selectedEmployee.employee_id}</p>
            <p><strong>Full Name:</strong> {selectedEmployee.full_name}</p>
            <p><strong>Username:</strong> {selectedEmployee.username}</p>
            <p><strong>Phone:</strong> {selectedEmployee.phone_number}</p>
            <p><strong>Email:</strong> {selectedEmployee.email}</p>
            <p><strong>Department:</strong> {selectedEmployee.department}</p>
            <p><strong>Designation:</strong> {selectedEmployee.designation}</p>
            <p><strong>Status:</strong> {selectedEmployee.status}</p>

            {/* Edit and Delete buttons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button style={editButtonStyle} onClick={() => handleEditClick(selectedEmployee)}>Edit</button>
              <button style={deleteButtonStyle} onClick={() => handleDeleteClick(selectedEmployee)}>Delete</button>
            </div>

            <button style={editButtonStyle} onClick={() => setSelectedEmployee(null)}>Close</button>
          </div>
        </div>
      )}

      {/* Inactive All Button */}
      <div style={{ marginTop: "20px", textAlign: "center" }}>
        <button style={deleteButtonStyle} onClick={handleInactiveAll}>Inactive All</button>
      </div>
    </div>
  );
}
